const url = 'https://www.wrike.com/form/eyJhY2NvdW50SWQiOjI0Mjk1ODQsInRhc2tGb3JtSWQiOjE5ODMwNH0JNDcwNTY1Nzc4ODcyMwk5ZWI1MmVkZGU2MTQ4NWYxMjhhNzJlYmEzODMzMzRhNDk2NjA0NzNmOWM5MTk3ZDY1YWUxZTI5Yzk2NjdmYWYz';

export default url;
